import { exclamationMark } from "../../../utils"
import "./ErrorHandling.css"

export interface ChatButtonMsgProps {
    errorText: string,
}

export const ChatButtonMsg: React.FC<ChatButtonMsgProps> = ({ errorText }) => {
    return <section className="errorMsg">
        <img src={exclamationMark} alt="exclamationMark" className="errorMsg__exclamationMark"/>
        <p className="errorMsg__text">
            {errorText}
        </p>
    </section>
}